/* i18n helper (global) */
if(typeof window!=="undefined" && typeof window.TR==="undefined"){window.TR=function(k,v){return (window.GS&&GS.t)?GS.t(k,v):k;};}
var TR=window.TR;
/* ux-report.js — UX Doctor's on-screenshot behavioural report. Reuses the Heatmaps plugin's stored
   screenshot + interaction grid and draws REAL, positioned signals on it: where visitors actually click
   (hotspot callouts) and how far they scroll before dropping off (fold lines). Only signals that have
   genuine coordinates are painted; session-level things stay as summary numbers, never faked onto x,y. */
(function () {
  function TT(k){ return (window.GS&&GS.t)?GS.t(k):k; }
  "use strict";
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
  function nf(n) { return (+n || 0).toLocaleString(); }
  function qp(k) { try { return new URLSearchParams(location.search).get(k) || ""; } catch (e) { return ""; } }
  function api(path) { return GS.api(path).then(function (r) { return (r && r.data) ? r.data : r; }); }

  /* ---- pure derivations (exposed for tests) ---- */
  function topClusters(cells, n) {
    var s = (cells || []).slice().sort(function (a, b) { return b.w - a.w; });
    return s.slice(0, n || 3).map(function (c, i) { return { gx: c.x, gy: c.y, w: c.w, rank: i + 1 }; });
  }
  /* scroll cells are a per-session max-depth histogram (gy = deepest bucket reached, w = sessions).
     reach(d) = sessions whose deepest point is at or below d; find where it drops under 50% / 25%. */
  function scrollDropoff(cells, GY) {
    GY = GY || 100;
    var hist = [], i, total = 0;
    for (i = 0; i < GY; i++) hist[i] = 0;
    (cells || []).forEach(function (c) { if (c.y >= 0 && c.y < GY) { hist[c.y] += c.w; total += c.w; } });
    if (!total) return [];
    var suffix = [], run = 0;
    for (i = GY - 1; i >= 0; i--) { run += hist[i]; suffix[i] = run; }
    var targets = [{ p: 0.5, label: TT('uxd.m.half_of_visitors_stop_scrolling_ab') }, { p: 0.25, label: TT('uxd.m.only_a_quarter_scroll_past_here') }];
    var out = [];
    targets.forEach(function (t) {
      var g = null;
      for (i = 0; i < GY; i++) { if (suffix[i] / total <= t.p) { g = i; break; } }
      if (g != null) out.push({ gy: g, reach: t.p, label: t.label });
    });
    return out;
  }
  function cellToPct(gx, gy, GX, GY) { return { x: (gx + 0.5) / GX * 100, y: (gy + 0.5) / GY * 100 }; }

  /* A page-level "mood" band from signals we actually measured: Frustration (rage-clicks), Engagement
     (scroll depth) and Focus (click concentration). No personas, no invented emotional climate. */
  function moodBand(d) {
    d = d || {};
    var GY = d.gy || 100, total = d.totalClicks || 0, rage = d.totalRage || 0;
    var clusters = d.clusters || [], drops = d.drops || [], pills = [];

    var ratio = total > 0 ? rage / total : (rage > 0 ? 1 : 0);
    if (rage === 0) pills.push({ label: TR('uxd.f.frustration'), value: "Calm", tone: "good", hint: "No rage-clicks detected" });
    else if (rage < 3 || ratio < 0.03) pills.push({ label: TR('uxd.f.frustration'), value: "Low", tone: "tip", hint: rage + " rage-click" + (rage === 1 ? "" : "s") });
    else if (ratio < 0.08) pills.push({ label: TR('uxd.f.frustration'), value: TR('uxd.f.elevated'), tone: "warn", hint: rage + " rage-clicks (" + Math.round(ratio * 100) + "% of clicks)" });
    else pills.push({ label: TR('uxd.f.frustration'), value: TR('uxdoct.high'), tone: "warn", hint: rage + " rage-clicks (" + Math.round(ratio * 100) + "% of clicks)" });

    if (drops.length) {
      var foldPct = Math.round((drops[0].gy + 0.5) / GY * 100);
      if (foldPct >= 70) pills.push({ label: TR('uxd.f.engagement'), value: TR('uxdoct.high'), tone: "good", hint: "Half scroll past " + foldPct + "%" });
      else if (foldPct >= 45) pills.push({ label: TR('uxd.f.engagement'), value: TR('uxd.f.moderate'), tone: "tip", hint: "Median fold at " + foldPct + "%" });
      else pills.push({ label: TR('uxd.f.engagement'), value: "Low", tone: "warn", hint: "Half leave by " + foldPct + "%" });
    } else pills.push({ label: TR('uxd.f.engagement'), value: "\u2014", tone: "tip", hint: TT('uxd.m.no_scroll_data_yet') });

    if (clusters.length && total > 0) {
      var share = Math.round(clusters[0].w / total * 100);
      if (share >= 50) pills.push({ label: TR('uxd.f.focus'), value: TR('uxd.f.focused'), tone: "tip", hint: share + "% of clicks on one spot" });
      else if (share >= 25) pills.push({ label: TR('uxd.f.focus'), value: TR('uxd.f.balanced'), tone: "tip", hint: "top spot = " + share + "% of clicks" });
      else pills.push({ label: TR('uxd.f.focus'), value: TR('uxd.f.scattered'), tone: "tip", hint: "clicks spread across the page" });
    } else pills.push({ label: TR('uxd.f.focus'), value: "\u2014", tone: "tip", hint: TT('uxd.m.no_click_data_yet') });

    return pills;
  }

  /* Turn the measured signals into plain-language, evidence-based reads. This never claims to know what
     a person thought — it says what the behaviour strongly suggests, and proposes a fix only where the
     data warrants one. Rules combine click + scroll, so it can explain the "why" behind the numbers. */
  function interpret(d) {
    d = d || {};
    var GY = d.gy || 100, clusters = d.clusters || [], drops = d.drops || [], total = d.totalClicks || 0;
    var cards = [];
    if (d.rageClusters && d.rageClusters.length) {
      var rc = d.rageClusters[0];
      var rPct = Math.round((rc.gy + 0.5) / GY * 100);
      var rn = d.totalRage || 0;
      cards.push({ tone: "warn", title: TR('uxd.f.visitors_are_rage_clicking'),
        text: "There's a spot around " + rPct + "% down where visitors click rapidly and repeatedly (" + rn + " rage-click" + (rn === 1 ? "" : "s") + " in total). That almost always means something looks clickable but doesn't respond \u2014 a broken link, a dead button, or a slow control.",
        action: TR('uxdoct.p.open_that_element_make_sure_it_actua') });
    }
    var foldGy = drops.length ? drops[0].gy : null;
    var foldPct = foldGy != null ? Math.round((foldGy + 0.5) / GY * 100) : null;

    if (foldPct != null) {
      if (foldPct <= 45) cards.push({ tone: "warn", title: TT('uxd.m.visitors_leave_early'),
        text: TR('uxdoct.p.half_of_them_stop_scrolling_by') + foldPct + "% down the page, so anything lower — including calls-to-action — is seen by fewer than half.",
        action: TR('uxdoct.p.move_your_key_message_and_main_butto') });
      else if (foldPct >= 75) cards.push({ tone: "good", title: TT('uxd.m.strong_scroll_depth'),
        text: "Half of visitors reach " + foldPct + "% of the page, so your lower content is genuinely being seen." });
      else cards.push({ tone: "tip", title: TT('uxd.m.average_scroll_depth'),
        text: TR('uxdoct.p.half_of_visitors_reach_about') + foldPct + "% down — the top of the page still does most of the work." });
    }

    if (clusters.length && total > 0) {
      var top = clusters[0];
      var share = Math.round(top.w / total * 100);
      var topPct = Math.round((top.gy + 0.5) / GY * 100);
      if (foldGy != null && top.gy > foldGy) cards.push({ tone: "warn", title: TT('uxd.m.your_busiest_spot_is_below_the_fol'),
        text: "The most-clicked spot (" + top.w.toLocaleString() + " clicks, " + share + "% of all clicks) sits at " + topPct + "% down — past where half of visitors stop. Everyone who doesn't scroll that far never sees it.",
        action: TR('uxdoct.p.move_this_element_up_its_real_potent') });
      else if (share >= 40) cards.push({ tone: "tip", title: TT('uxd.m.attention_is_concentrated'),
        text: share + "% of every click lands on one spot. If that's your primary action it's working — if not, it may be pulling attention away from what matters." });
      else cards.push({ tone: "good", title: TT('uxd.m.clicks_are_spread_sensibly'),
        text: TR('uxdoct.p.no_single_spot_dominates_visitors_in') });

      cards.push({ tone: "tip", title: TT('uxd.m.check_what_sits_under_the_top_spot'),
        text: TR('uxd.f.if_the_busiest_spot_isn_t_a_link_or_bu'),
        action: TR('uxdoct.p.make_it_clickable_or_restyle_it_so_i') });
    }

    if (!cards.length) cards.push({ tone: "tip", title: TT('uxd.m.not_enough_data_yet'),
      text: TR('uxdoct.p.once_visitors_browse_this_page_ghost') });
    return cards;
  }

  function renderReport(container, data) {
    data = data || {};
    var GX = data.gx || 50, GY = data.gy || 100;
    var clusters = topClusters(data.clickCells, 3);
    var drops = scrollDropoff(data.scrollCells, GY);
    var totalClicks = (data.clickCells || []).reduce(function (a, c) { return a + c.w; }, 0);
    var rageClusters = topClusters(data.rageCells, 3);
    var totalRage = (data.rageCells || []).reduce(function (a, c) { return a + c.w; }, 0);
    var band = moodBand({ clusters: clusters, drops: drops, totalClicks: totalClicks, totalRage: totalRage, gy: GY });
    var h = '<div class="uxr-band">' + band.map(function (pl) {
      return '<div class="uxr-pill uxr-' + pl.tone + '"><div class="pl">' + esc(pl.label) + '</div><div class="pv">' + esc(pl.value) + '</div><div class="ph">' + esc(pl.hint) + "</div></div>";
    }).join("") + "</div>";
    h += '<div class="uxr-summary">'
      + "<span><b>" + nf(totalClicks) + "</b> clicks</span>"
      + "<span><b>" + clusters.length + "</b> hotspots</span>"
      + (totalRage ? '<span><b class="uxr-rage-n">' + nf(totalRage) + "</b> rage-clicks</span>" : "")
      + (drops.length ? "<span>Median fold \u2248 <b>" + Math.round((drops[0].gy + 0.5) / GY * 100) + "%</b> down</span>" : "")
      + '</div><div class="uxr-stage">';
    h += data.img
      ? '<img class="uxr-shot" src="' + data.img + '" alt="'+TT('uxd.at.page_screenshot')+'">'
      : '<div class="uxr-noshot">No screenshot captured for this page yet \u2014 GhostStat grabs one the next time a sampled visitor loads it.</div>';
    h += '<div class="uxr-layer">';
    drops.forEach(function (d) {
      var y = (d.gy + 0.5) / GY * 100;
      h += '<div class="uxr-drop" style="top:' + y.toFixed(2) + '%"><span>' + esc(d.label) + "</span></div>";
    });
    clusters.forEach(function (c) {
      var p = cellToPct(c.gx, c.gy, GX, GY);
      h += '<div class="uxr-cluster" style="left:' + p.x.toFixed(2) + "%;top:" + p.y.toFixed(2) + '%">'
        + '<i class="uxr-dot">' + c.rank + "</i>"
        + '<div class="uxr-note"><b>' + c.rank + '. Click hotspot</b><br>' + nf(c.w) + " clicks here</div></div>";
    });
    rageClusters.forEach(function (c) {
      var p = cellToPct(c.gx, c.gy, GX, GY);
      h += '<div class="uxr-rage" style="left:' + p.x.toFixed(2) + "%;top:" + p.y.toFixed(2) + '%">'
        + '<i class="uxr-rage-dot">\u26a1</i>'
        + '<div class="uxr-note uxr-rage-note"><b>'+TR('uxd.f.rage_clicks')+'</b><br>' + nf(c.w) + " rapid clicks here</div></div>";
    });
    h += "</div></div>";

    var insight = interpret({ clusters: clusters, drops: drops, totalClicks: totalClicks, rageClusters: rageClusters, totalRage: totalRage, gy: GY });
    h += '<div class="uxr-insight"><div class="uxr-insight-h">'+TT('uxd.js.what_this_suggests')+'</div>';
    insight.forEach(function (card) {
      h += '<div class="uxr-card uxr-' + card.tone + '"><div class="uxr-card-t">' + esc(card.title) + "</div>"
        + '<div class="uxr-card-x">' + esc(card.text) + "</div>"
        + (card.action ? '<div class="uxr-card-a"><b>Try:</b> ' + esc(card.action) + "</div>" : "") + "</div>";
    });
    h += '<div class="uxr-honest">GhostStat describes what the behaviour shows — it can\u2019t read individual minds, so treat these as strong hints, not certainties.</div></div>';
    container.innerHTML = h;
  }

  window.__uxReport = { topClusters: topClusters, scrollDropoff: scrollDropoff, cellToPct: cellToPct, interpret: interpret, moodBand: moodBand, renderReport: renderReport };

  /* ---- viewer ---- */
  function boot() {
    var canvas = document.querySelector('[data-uxr="canvas"]'); if (!canvas) return;
    var pageSel = document.querySelector('[data-uxr="page"]');
    var deviceSel = document.querySelector('[data-uxr="device"]');
    function load() {
      if (!pageSel || !pageSel.value) { canvas.innerHTML = '<div class="uxr-noshot">'+TR('uxd.f.pick_a_page_above')+'</div>'; return; }
      var q = "site=" + encodeURIComponent(GS.site || "") + "&page=" + encodeURIComponent(pageSel.value) + "&device=" + encodeURIComponent((deviceSel && deviceSel.value) || "desktop");
      canvas.innerHTML = '<div class="uxr-noshot">Loading\u2026</div>';
      Promise.all([
        api("/plugin/heatmaps/shot?" + q),
        api("/plugin/heatmaps/render?" + q + "&layer=click"),
        api("/plugin/heatmaps/render?" + q + "&layer=scroll"),
        api("/plugin/heatmaps/render?" + q + "&layer=rage")
      ]).then(function (res) {
        var shot = res[0] || {}, click = res[1] || {}, scroll = res[2] || {}, rage = res[3] || {};
        if (click && click.ok === false) { canvas.innerHTML = '<div class="uxr-noshot">'+TT('uxd.js.enable_hm_pre')+' <b>'+TR('uxd.f.heatmaps')+'</b> '+TT('uxd.js.enable_hm_post')+'shot report.</div>'; return; }
        renderReport(canvas, { img: shot && shot.img ? shot.img : null, gx: click.gx || 50, gy: click.gy || 100, clickCells: click.cells || [], scrollCells: scroll.cells || [], rageCells: rage.cells || [] });
      }).catch(function () { canvas.innerHTML = '<div class="uxr-noshot">Couldn\u2019t load the report.</div>'; });
    }
    function fillPages() {
      api("/plugin/heatmaps/pages?site=" + encodeURIComponent(GS.site || "")).then(function (r) {
        if (r && r.ok === false) { if (pageSel) pageSel.innerHTML = '<option value="">'+TT('uxd.js.enable_heatmaps')+'</option>'; canvas.innerHTML = '<div class="uxr-noshot">'+TT('uxd.js.enable_hm_pre')+' <b>'+TR('uxd.f.heatmaps')+'</b> '+TT('uxd.js.enable_hm_report')+'</div>'; return; }
        var pages = (r && r.pages) || [];
        pages.sort(function (a, b) { return (b.samples || 0) - (a.samples || 0); });
        if (!pages.length) { if (pageSel) pageSel.innerHTML = '<option value="">'+TT('uxd.js.no_pages_tracked_yet')+'</option>'; canvas.innerHTML = '<div class="uxr-noshot">No heatmap data yet \u2014 browse the site so GhostStat can capture a page.</div>'; return; }
        if (pageSel) pageSel.innerHTML = pages.map(function (pg) {
          return '<option value="' + esc(pg.page_url) + '">' + esc(pg.page_url) + " \u00b7 " + nf(pg.samples) + " samples</option>";
        }).join("");
        var want = qp("page");
        if (want && pageSel && Array.prototype.some.call(pageSel.options, function (o) { return o.value === want; })) pageSel.value = want;
        load();
      }).catch(function () { if (pageSel) pageSel.innerHTML = '<option value="">Couldn\u2019t load pages</option>'; });
    }
    if (pageSel) pageSel.onchange = load;
    if (deviceSel) deviceSel.onchange = load;
    fillPages();
  }
  function ready() { return window.GS && GS.api && GS.site; }
  if (document.querySelector('[data-uxr="canvas"]')) {
    if (ready()) boot();
    else { var t = setInterval(function () { if (ready()) { clearInterval(t); boot(); } }, 60); setTimeout(function () { clearInterval(t); }, 5000); }
  }
})();
